<template>
  <div class="segment-duration-selector">
    <span class="label">切片时长：</span>
    <el-radio-group
      :value="value"
      size="medium"
      :disabled="disabled"
      class="duration-radio-group"
      @input="$emit('input', $event)"
    >
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
      >
        <span class="duration-option">
          <span class="duration-option__time">{{ item.label }}</span>
          <!-- <span class="duration-option__hint">{{ item.hint }}</span> -->
        </span>
      </el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import { SEGMENT_DURATIONS } from '../constants/segmentDurations';

export default {
  name: 'SegmentDurationSelector',
  props: {
    value: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    options() {
      return SEGMENT_DURATIONS;
    },
  },
};
</script>

<style scoped>
.segment-duration-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
}
.label {
  font-weight: 500;
  color: #374151;
  flex-shrink: 0;
}
.duration-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.duration-radio-group >>> .el-radio-button__inner {
  padding: 10px 14px;
  height: auto;
  line-height: 1.3;
}
.duration-option {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  white-space: nowrap;
}
.duration-option__time {
  font-weight: 600;
}
.duration-option__hint {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}
.duration-radio-group >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner .duration-option__hint {
  color: rgba(255, 255, 255, 0.85);
}
</style>
